<!--
Settings screen
@author bmk11u, ab557z
TODO : STOP MUTATING PROP
-->
<template>
  <div id="contain" class="container">
    <Nav name="Settings" :step="true" />
    <div id="settingsContainer">
      <div id="lateChangesWrapper" class="settings-section">
        <h2 class="settings-header">Late timetable changes</h2>
        <div class="setting-row">
          <p id="pushNotificationLabel">Push Notifications</p>
              <ToggleButton name="LATE_CHANGE_NOTIFICATION" :toggle="displaySetting['LATE_CHANGE_NOTIFICATION']" @settingSaved="showSavedMessage" labelledBy="pushNotificationLabel"
              />
        </div>
        <div class="setting-row">
          <p id="smsNotificationLabel">SMS Notifications</p>
              <ToggleButton name="LATE_CHANGE_SMS" :toggle="displaySetting['LATE_CHANGE_SMS']" @settingSaved="showSavedMessage" labelledBy="smsNotificationLabel"
              />
        </div>
      </div>
      <div id="timetableDefaultWrapper" class="settings-section">
        <h2 class="settings-header">Timetable default view</h2>
        <div class="setting-row">
          <p id="timetableViewDay">Day</p>
          <RadioButton name="TIMETABLE_DEFAULT_VIEW" value="D" :checked="timetableDefaultChecked('D')" @settingSaved="showSavedMessage" labelledBy="timetableViewDay"/>
        </div>
        <div class="setting-row">
          <p id="timetableViewWeek">Week</p>
          <RadioButton name="TIMETABLE_DEFAULT_VIEW" value="W" :checked="timetableDefaultChecked('W')" @settingSaved="showSavedMessage" labelledBy="timetableViewWeek"/>
        </div>
        <div class="setting-row">
          <p id="timetableViewMonth">Month</p>
          <RadioButton name="TIMETABLE_DEFAULT_VIEW" value="M" :checked="timetableDefaultChecked('M')" @settingSaved="showSavedMessage" labelledBy="timetableViewMonth"/>
        </div>
      </div>
    </div>
    <TransitionGroup tag="div" name="savedMessages" id="savedMessageContainer" class="container" v-if="savedNotices.length > 0">
      <div class="settings-saved"  v-for="(item) in savedNotices" :key="item">
        <p>Settings updated <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon></p>
      </div>
    </TransitionGroup>

    <div id="pusher"></div>
    <Footer active="settings"/>
  </div>
</template>

<script setup>
//Utilities
import {ref, onMounted } from 'vue'
import axios from 'axios'
import * as lst from '@/components/localStorage.js'

//Components
import ToggleButton from '@/components/ToggleButton.vue'
import Footer from '@/components/FooterMenu.vue'
import RadioButton from '@/components/RadioButton.vue'

//Data
const displaySetting = ref({})
const settings = ref({})
const savedNotices = ref([])
let nextId = ref(0)

onMounted(
  () => {
    // Timetable default view is handled through localStorage...
    displaySetting.value["TIMETABLE_DEFAULT_VIEW"] = lst.getValue('timetableDefaultView')
    // Fetch the sms setting from the the server. There are only 2 editable setting right now (excluding timetable view).
    axios.get('/timetable/settings')
      .then(response => {
        settings.value = response.data
        for (var i = 0; i < settings.value.length; i++) {

          //Late change settings
          if(settings.value[i].id.settingName == 'LATE_CHANGE_NOTIFICATION' || settings.value[i].id.settingName == 'LATE_CHANGE_SMS') {
            if (settings.value[i].settingValue == 'Y') {
              displaySetting.value[settings.value[i].id.settingName] = true
            } else {
              displaySetting.value[settings.value[i].id.settingName] = false
            }
          }
        }
      })
  }
)

function timetableDefaultChecked(settingName) {
  return settingName === displaySetting.value['TIMETABLE_DEFAULT_VIEW'] ? "checked" : null
}


function showSavedMessage() {
  //Add to the array that the v-for uses to display saved messages
  savedNotices.value.push(nextId.value++)
  //Remove the first entry in the array after 5 seconds
  setTimeout(() => {
    savedNotices.value.shift()
  }, 5000)
}

</script>

<style>
.settings-section {
    padding-bottom: 25px;
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
}

.settings-section:last-child {
  border-bottom: none;
}

.setting-row {
    display: flex;
}

.setting-row p{
    flex-basis:100%;
}

.settings-section h2{
    font-size:1rem;
    font-weight:bold;
    text-align:left;
    color: #1D1D1D;
    margin-bottom:22px;
}

#settingsContainer {
    padding: 25px;
}

/** Saved notice **/
#savedMessageContainer {
    position: fixed;
    top: 74px;
    padding: 0px;
}

.settings-saved {
  padding: 0.5rem;
  border: 1px solid #8BC34A;
  color: #1d1d1d;
  background: #8BC34A;
  margin: 0 auto;
  text-align: center;
  transition: all 0.3s;
  right:0;
  left:0;
}

.settings-saved p {
    margin-bottom: 0px;
}

/* Transition */
.savedMessages-move,
.savedMessages-enter-active,
.savedMessages-leave-active {
  transition: all 0.5s ease;
}

.savedMessages-enter-from,
.savedMessages-leave-to {
  opacity: 0;
}

.savedMessages-leave-active {
  position: absolute;
}
</style>
